import { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ChangePasswordModal from "../../../pages/auth/change password";
import SignoutModal from "../../../pages/auth/signout";
import Image from "../../UI/Image";
import "./style.scss";
import { textIdentifier } from "../../../textIdentifier";

export default function SecondaryHeader({
  title = "",
  profile = true,
  navigateBackto = -1,
  redirect
}) {
  const userData = useSelector((state) => state.auth.userData);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showSignoutModal, setShowSignoutModal] = useState(false);
  const {lang} = useSelector(state => state.main)

  const navigate = useNavigate();

  const handleBack = (e) => {
    e.preventDefault();
    if(redirect!=null){
      navigate(Number(redirect));
    }
    else{
      navigate(navigateBackto);
    }
  };

  const handleShowChangePasswordModal = () => setShowChangePasswordModal(true);
  const handleCloseChangePasswordModal = () =>
    setShowChangePasswordModal(false);

  const handleShowSignoutModal = () => setShowSignoutModal(true);
  const handleCloseSignoutModal = () => setShowSignoutModal(false);

  return (
    <header className="secondary-header">
      {/* back button */}
      <nav>
        <img
          onClick={handleBack}
          src={"/static/images/svg/arrow-left.svg"}
          alt="star"
          className="back"
          title="go back"
        />
        {/* divider */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="2"
          height="36"
          viewBox="0 0 2 36"
          fill="none"
        >
          <line
            x1="0.75"
            y1="0.75"
            x2="0.749999"
            y2="35.25"
            stroke="#B1ABBA"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>

        {/* nav links */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <div className="content">
              <Link to={"/"} className="nav-link active" aria-current="page">
                <img src="/static/images/svg/home.svg" alt="home icon" />{" "}
                <span>{textIdentifier['home'][lang]}</span>
              </Link>
            </div>
            <div className="underline"></div>
          </li>
        </ul>

        {/* title */}
        <div className="title">{title}</div>

        {/* user dropdown */}
        {profile ? (
          <div className="dropdown">
            <button
              className="btn dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              data-bs-offset="50,12"
              aria-expanded="false"
            >
              <Image src={userData.profileImage} alt={userData.first_name} />

              <span>{textIdentifier['hi'][lang]}, {userData.first_name}</span>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="10"
                viewBox="0 0 17 10"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.468703 0.668149C0.768747 0.368195 1.17564 0.19969 1.5999 0.19969C2.02417 0.19969 2.43106 0.368195 2.7311 0.668149L7.9999 5.93695L13.2687 0.668149C13.4163 0.515333 13.5928 0.393441 13.7881 0.309586C13.9833 0.225732 14.1932 0.181594 14.4057 0.179748C14.6181 0.177902 14.8288 0.218384 15.0254 0.298834C15.2221 0.379283 15.4007 0.498088 15.5509 0.648316C15.7012 0.798545 15.82 0.977188 15.9004 1.17382C15.9809 1.37046 16.0214 1.58114 16.0195 1.79359C16.0177 2.00604 15.9735 2.21599 15.8897 2.4112C15.8058 2.6064 15.6839 2.78295 15.5311 2.93055L9.1311 9.33055C8.83106 9.6305 8.42416 9.79901 7.9999 9.79901C7.57564 9.79901 7.16875 9.6305 6.8687 9.33055L0.468703 2.93055C0.168749 2.6305 0.000244141 2.22361 0.000244141 1.79935C0.000244141 1.37509 0.168749 0.968193 0.468703 0.668149Z"
                  fill="#0059B1"
                />
              </svg>
            </button>

            <ul
              className="dropdown-menu shadow"
              aria-labelledby="dropdownMenuButton1"
            >
              <li>
                <a
                  className="dropdown-item"
                  onClick={(e) => {
                    e.preventDefault();
                    handleShowChangePasswordModal();
                  }}
                >
                  {textIdentifier['change-password'][lang]}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 42 42"
                    fill="none"
                  >
                    <path
                      d="M13.7117 8.21973C14.967 8.11954 16.1587 7.62596 17.1172 6.80923C18.2003 5.8857 19.5771 5.37842 21.0005 5.37842C22.4238 5.37842 23.8006 5.8857 24.8837 6.80923C25.8422 7.62596 27.0339 8.11954 28.2892 8.21973C29.708 8.33261 31.0402 8.94743 32.0466 9.95385C33.053 10.9603 33.6678 12.2924 33.7807 13.7112C33.8809 14.9665 34.3745 16.1582 35.1912 17.1167C36.1148 18.1998 36.622 19.5766 36.622 21C36.622 22.4234 36.1148 23.8001 35.1912 24.8832C34.3745 25.8417 33.8809 27.0334 33.7807 28.2887C33.6678 29.7076 33.053 31.0397 32.0466 32.0461C31.0402 33.0525 29.708 33.6674 28.2892 33.7802C27.0339 33.8804 25.8422 34.374 24.8837 35.1907C23.8006 36.1143 22.4238 36.6216 21.0005 36.6216C19.5771 36.6216 18.2003 36.1143 17.1172 35.1907C16.1587 34.374 14.967 33.8804 13.7117 33.7802C12.2929 33.6674 10.9608 33.0525 9.95434 32.0461C8.94791 31.0397 8.3331 29.7076 8.22022 28.2887C8.12003 27.0334 7.62645 25.8417 6.80972 24.8832C5.88619 23.8001 5.37891 22.4234 5.37891 21C5.37891 19.5766 5.88619 18.1998 6.80972 17.1167C7.62645 16.1582 8.12003 14.9665 8.22022 13.7112C8.3331 12.2924 8.94791 10.9603 9.95434 9.95385C10.9608 8.94743 12.2929 8.33261 13.7117 8.21973Z"
                      stroke="#2E2E2E"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M17.5 19.25V15.75C17.5 14.8217 17.8687 13.9315 18.5251 13.2751C19.1815 12.6187 20.0717 12.25 21 12.25C21.9283 12.25 22.8185 12.6187 23.4749 13.2751C24.1313 13.9315 24.5 14.8217 24.5 15.75M21 22.75V24.5M15.75 28H26.25C26.7141 28 27.1592 27.8156 27.4874 27.4874C27.8156 27.1592 28 26.7141 28 26.25V21C28 20.5359 27.8156 20.0908 27.4874 19.7626C27.1592 19.4344 26.7141 19.25 26.25 19.25H15.75C15.2859 19.25 14.8408 19.4344 14.5126 19.7626C14.1844 20.0908 14 20.5359 14 21V26.25C14 26.7141 14.1844 27.1592 14.5126 27.4874C14.8408 27.8156 15.2859 28 15.75 28Z"
                      stroke="#2E2E2E"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>
              </li>

              <li>
                <a
                  className="dropdown-item"
                  onClick={(e) => {
                    e.preventDefault();
                    handleShowSignoutModal();
                  }}
                >
                  {textIdentifier['logout'][lang]}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 34 30"
                    fill="none"
                  >
                    <path
                      d="M18.75 22V23.75C18.75 25.1424 18.1969 26.4777 17.2123 27.4623C16.2277 28.4469 14.8924 29 13.5 29H6.5C5.10761 29 3.77226 28.4469 2.78769 27.4623C1.80312 26.4777 1.25 25.1424 1.25 23.75V6.25C1.25 4.85761 1.80312 3.52226 2.78769 2.53769C3.77226 1.55312 5.10761 1 6.5 1H13.5C14.8924 1 16.2277 1.55312 17.2123 2.53769C18.1969 3.52226 18.75 4.85761 18.75 6.25V8M25.75 22L32.75 15L25.75 22ZM32.75 15L25.75 8L32.75 15ZM32.75 15H8.25H32.75Z"
                      stroke="#2E2E2E"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        ) : null}
      </nav>

      {/* Logout Modal */}
      {showSignoutModal && (
        <SignoutModal handleClose={handleCloseSignoutModal} />
      )}
      {/* Change Password Modal */}
      {showChangePasswordModal && (
        <ChangePasswordModal handleClose={handleCloseChangePasswordModal} />
      )}
    </header>
  );
}
